import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import type { ExportTaxonomicGroupsResponse } from "./type";

export async function exportTaxonomicGroups(): Promise<ExportTaxonomicGroupsResponse> {
  const response = await apiClient.get<ExportTaxonomicGroupsResponse>(
    apiPaths.taxonomicGroups.export,
  );

  return response.data;
}
